import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import Image from 'next/image'
import { IMAGE_BLUR_URL } from '../../utils/constants'
import renderOptions from './renderOptions'

const Need2KnowHeader = ({ heroImage, body }) => (
  <>
    <div className='hero-section'>
      <Image
        src={heroImage?.url}
        width={heroImage?.width}
        height={heroImage?.height}
        alt='Need2Know'
        layout='responsive'
        placeholder='blur'
        blurDataURL={IMAGE_BLUR_URL}
      />
      {documentToReactComponents(body, renderOptions)}
    </div>
  </>
)

export default Need2KnowHeader
